import React from 'react';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { AskDataIndexing } from '~src/ts/models/IDataSourceInfo';

interface AskDataReadingModeProps {
  readonly askDataIndexing: AskDataIndexing;
  readonly feedbackToCurator: boolean;
}

export function AskDataReadingMode(props: AskDataReadingModeProps): JSX.Element {
  const indexingLabelMap = {
    [AskDataIndexing.automatic]: Messages.datasourceAskData_indexing_automatic(),
    [AskDataIndexing.manual]: Messages.datasourceAskData_indexing_manual(),
    [AskDataIndexing.disabled]: Messages.datasourceAskData_indexing_disabled(),
  };

  return (
    <>
      <div>
        {Messages.dataSourceNlpSetting_option_Title()}: {indexingLabelMap[props.askDataIndexing]}
      </div>
      {FeatureFlags.nlFeedbackToCuratorEnabled &&
        <div>
          {Messages.dataSourceNlpSetting_feedbackToCuratorTitle()}:&nbsp;
          {props.feedbackToCurator ?
            Messages.datasourceAskData_feedback_to_curator_enabled() :
            Messages.datasourceAskData_feedback_to_curator_disabled()
          }
        </div>
      }
    </>
  );
}
